module.exports = __webpack_public_path__ + "img/herotext-md.9bc36920.png";